import React from 'react';
import ShowcaseCard from '../showcase-card/showcase-card';
import {TimeBlock} from '../time-block/time-block';
import {CtaButton} from '../cta-button/cta-button';
import {StageLights} from '../stage-lights/stage-lights';
import LinearText from '../linear-text/linear-text';
import { ImageRaw } from '../../../../components/image-raw';
const featureCardsData = [
    {
        title: 'ĐẠI TIỆC ÂM NHẠC CẢM XÚC',
        description: 'Dành cho khách hàng',
    },
    {
        title: 'SỰ KIỆN ÂM NHẠC TRI ÂN',
        description: 'Món quà ý nghĩa KidsPlaza trao tặng khách hàng',
    },
    {
        title: 'SÂN KHẤU VƯƠN MÌNH TƯƠNG LAI',
        description: 'Nơi kết hợp nghệ thuật, cảm xúc và khát vọng vươn xa',
    },
];

export const VibrantConcertPromo = () => {
    return (
        <div className="relative flex min-h-screen flex-col items-center overflow-hidden bg-[#1709d8] p-8 font-sans text-center text-white">
            {/* === THÊM HIỆU ỨNG ĐÈN SÂN KHẤU === */}
            <StageLights />
            {/* ==================================== */}
            {/* === CONTAINER CHO CÁC HIỆU ỨNG ÁNH SÁNG MỜ === */}
            <div aria-hidden="true" className="absolute inset-0 z-0">
                {/* 1. Vệt sáng ở góc trên bên phải (ĐÃ CẬP NHẬT) */}
                <div className="absolute right-0 top-0 h-[500px] w-[500px] -translate-y-1/4 translate-x-1/4 rounded-full bg-[radial-gradient(circle_at_center,_#FC57FF_0%,_#020202_100%)] opacity-100 blur-[160px]" />

                {/* 2. Vệt sáng ở giữa bên trái */}
                <div className="absolute left-0 top-1/2 h-[400px] w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle_at_center,_#FC57FF_0%,_#020202_100%)] opacity-100 blur-[120px]" />

                {/* 3. Vệt sáng ở góc dưới bên phải */}
                <div className="absolute bottom-0 right-0 h-[350px] w-[350px] translate-x-1/4 translate-y-1/4 rounded-full bg-[radial-gradient(circle_at_center,_#FC57FF_0%,_#020202_100%)] opacity-100 blur-[140px]" />
            </div>
            {/* ============================================== */}

            {/* Container cho nội dung, nằm bên trên các vệt sáng */}
            <div className="relative flex w-full flex-col items-center max-w-[1200px]">
                <header className="mb-8">
                    <div className="flex flex-col items-center">
                        {/* <Image width={480} height={314} src={'images/vuon-concert-logo.png'} alt="Vươn Concert Logo" /> */}
                        <ImageRaw src={'images/vuon-concert-logo.png'} alt="Vươn Concert Logo" />
                        {/*<span className="font-['Brush_Script_MT'] text-7xl font-bold text-yellow-400 drop-shadow-lg">*/}
                        {/*  Vươn*/}
                        {/*</span>*/}
                        {/*<span*/}
                        {/*  className="mt-1 bg-gradient-to-r from-pink-500 to-cyan-300 bg-clip-text text-2xl font-bold tracking-widest text-transparent">*/}
                        {/*  CONCERT*/}
                        {/*</span>*/}
                    </div>
                </header>
                <div className="mb-6 w-1/2 max-w-3xl rounded-2xl backdrop-blur-sm overflow-hidden">
                    {/* Đặt hình ảnh ở đây */}
                    <ImageRaw
                        src={'images/singers.png'}
                        alt="Ca sĩ biểu diễn tại Vươn Concert"
                        className="h-full w-full object-cover"
                    />
                </div>

                <main className="flex w-full flex-col items-center mx-[14px]">
                    <div className="w-full">
                        <TimeBlock location="SÂN VẬN ĐỘNG QUẦN NGỰA" time="20:00" day="CHỦ NHẬT" date="05.10.2025" />
                    </div>

                    <CtaButton text="ĐĂNG KÝ NHẬN VÉ MIỄN PHÍ NGAY" />

                    <section className="my-8">
                        <LinearText className='mt-2 text-[56px] font-extrabold bg-[linear-gradient(to_right,_#6CF5FF_0%,_#92C3F3_41%,_#FF77E1_76%,_#FF398C_100%)] bg-clip-text text-transparent drop-shadow-lg'>
                            VƯƠN CONCERT
                        </LinearText>
                        <p className="mx-auto mt-5 max-w-3xl text-sm font-bold leading-relaxed">
                            Tương lai chính là con. Vươn mình cùng tương lai là cùng vươn cao,
							vươn xa với con của mẹ. KidsPlaza không chỉ đồng hành cùng trẻ em
							– mà còn cùng dân tộc vươn mình trong kỷ nguyên mới. KidsPlaza đã
							đi qua 10 bước chân của một hành trình phụng sự. Giờ đây, chúng ta
							không chỉ mơ cho con – mà mơ cùng con. Không chỉ vươn mình – mà
							vươn mình cùng dân tộc. Tương lai là con, và tương lai đang bắt
							đầu từ hôm nay.
                        </p>
                    </section>

                    <section className="mt-8 w-full">
                        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                            {featureCardsData.map(card => (
                                <ShowcaseCard key={card?.title} headline={card.title} description={card.description} />
                            ))}
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
};
